const sectionSocialMediaCss = `
[data-type='section-social-media'] .container {
  padding-inline: 0 !important;
}

[data-type='section-social-media'] .social-media-wrapper {
  padding-block: 40px;
}

[data-type='section-social-media'] .social-media-title h1,
[data-type='section-social-media'] .social-media-title h2,
[data-type='section-social-media'] .social-media-title h3 {
  font-size: 24px;
  line-height: 29px;
  margin: 0 0 24px 0 !important;
}

[data-type='section-social-media'] .social-media-title h1:last-child,
[data-type='section-social-media'] .social-media-title h2:last-child,
[data-type='section-social-media'] .social-media-title h3:last-child {
  margin: 0 !important;
}

[data-type='section-social-media'] .social-media-title p {
  font-size: 16px;
  margin-bottom: 16px !important;
}

[data-type='section-social-media'] .social-media-title p:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-social-media'] .social-media-posts {
  column-count: 2;
  column-gap: 20px;
  margin-top: 24px !important;
}

[data-type='section-social-media'] .post-item-wrapper {
  padding: 16px;
  background-color: #f0f2f5;
  margin-bottom: 20px;
}

[data-type='section-social-media'] .post-item-wrapper:last-child {
  margin-bottom: 0;
}

[data-type='section-social-media'] .post-item {
  padding: 16px;
  background-color: #ffffff;
  border-radius: 12px;
}

[data-type='section-social-media'] .post-info .post-author-info-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

[data-type='section-social-media'] .post-info .post-author-info-wrapper .post-author {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 16px;
}

[data-type='section-social-media'] .post-info .post-author-info-wrapper .post-author .post-author-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
}

[data-type='section-social-media'] .post-info .post-author-info-wrapper .post-author .post-author-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

[data-type='section-social-media'] .post-info .post-author-info-wrapper .post-author .post-author-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

[data-type='section-social-media'] .post-info .post-author-info-wrapper .post-author .post-author-info .post-author-name {
  margin: 0px !important;
  line-height: normal;
  font-size: 16px !important;
}

[data-type='section-social-media'] .post-info .post-author-info-wrapper .post-author .post-author-info .post-author-time {
  display: flex;
  align-items: center;
  gap: 8px;
}

[data-type='section-social-media'] .post-info .post-author-info-wrapper .post-author .post-author-info .post-author-time .post-author-time-text {
  margin: 0 !important;
  font-size: 14px;
  opacity: 0.6;
  flex: 1;
  width: fit-content;
  max-width: fit-content;
  line-height: normal;
}

[data-type='section-social-media'] .post-info .post-author-info-wrapper .post-author .post-author-info .post-author-time .post-author-public-icon {
  width: 12px;
  height: 12px;
}

[data-type='section-social-media'] .post-info .post-author-info-wrapper .post-more-icon {
  width: 20px;
  height: 20px;
}

[data-type='section-social-media'] .post-content {
  margin: 20px 0 0 0 !important;
}

[data-type='section-social-media'] .post-reaction {
  margin-top: 20px;
}

[data-type='section-social-media'] .post-reaction .post-reaction-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

[data-type='section-social-media'] .post-reaction .post-reaction-wrapper .post-reaction-icon {
  display: flex;
  align-items: center;
}

[data-type='section-social-media'] .post-reaction .post-reaction-wrapper .post-reaction-icon img {
  width: 18px;
  height: 18px;
  object-fit: cover;
}

[data-type='section-social-media'] .post-reaction .post-reaction-wrapper .post-reaction-icon .post-reaction-likes-count {
  margin: 2px 0 0 4px !important;
  font-size: 14px;
  opacity: 0.6;
}

[data-type='section-social-media'] .post-reaction .post-reaction-wrapper .post-reaction-comments-count {
  margin: 0 !important;
  font-size: 14px;
  opacity: 0.6;
}

[data-type='section-social-media'] .post-reaction .post-reaction-button-wrapper {
  margin-top: 12px;
  padding: 12px 0;
  border-top: solid 1px #e5e7eb;
  border-bottom: solid 1px #e5e7eb;
  display: flex;
  align-items: center;
  gap: 16px;
}

[data-type='section-social-media'] .post-reaction .post-reaction-button-wrapper .post-reaction-button {
  display: flex;
  align-items: center;
  gap: 4px;
}

[data-type='section-social-media'] .post-reaction .post-reaction-button-wrapper .post-reaction-button svg {
  width: 16px;
  height: 16px;
  opacity: 0.6;
}

[data-type='section-social-media'] .post-reaction .post-reaction-button-wrapper .post-reaction-button p {
  margin: 0 !important;
  font-size: 14px;
  opacity: 0.6;
}

[data-type='section-social-media'] .post-comments {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

[data-type='section-social-media'] .post-comments .post-comment-item {
  display: flex;
  gap: 8px;
}

[data-type='section-social-media'] .post-comments .post-comment-item .post-comment-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
}

[data-type='section-social-media'] .post-comments .post-comment-item .post-comment-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

[data-type='section-social-media'] .post-comments .post-comment-item .post-comment-content {
  flex: 1;
}

[data-type='section-social-media'] .post-comments .post-comment-item .post-comment-content .post-comment-content-header {
  border-radius: 12px;
  padding: 8px 16px;
  background-color: #f0f2f5;
  height: fit-content;
}

[data-type='section-social-media'] .post-comments .post-comment-item .post-comment-content .post-comment-content-header .post-comment-content-header-name {
  margin: 0 0 4px 0 !important;
  font-size: 16px;
  font-weight: 500;
}

[data-type='section-social-media'] .post-comments .post-comment-item .post-comment-content .post-comment-content-header .post-comment-content-header-text {
  margin: 0 !important;
  font-size: 14px;
}

[data-type='section-social-media'] .post-comments .post-comment-item .post-comment-content .post-comment-content-footer {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 12px !important;
  margin-left: 16px !important;
}

[data-type='section-social-media'] .post-comments .post-comment-item .post-comment-content .post-comment-content-footer p {
  margin: 0 !important;
  font-size: 12px;
  opacity: 0.6;
}

@container (max-width: 768px) {
  [data-type='section-social-media'] .social-media-wrapper {
    padding-block: 16px;
  }

  [data-type='section-social-media'] .social-media-title h1,
  [data-type='section-social-media'] .social-media-title h2,
  [data-type='section-social-media'] .social-media-title h3 {
    font-size: 20px;
    line-height: 24px;
  }

  [data-type='section-social-media'] .social-media-title p {
    font-size: 14px;
  }

  [data-type='section-social-media'] .social-media-posts {
    column-count: 1;
  }

  [data-type='section-social-media'] .post-item-wrapper {
    padding: 8px;
    margin-bottom: 0;
  }
}
`;
export default sectionSocialMediaCss;
